import * as moment from 'moment';

export function beginEndDateToString(beginDate: Date, endDate: Date): string {
  const beginMoment = moment(beginDate);
  const endMoment = moment(endDate);
  if (beginDate.getTime() === endDate.getTime()) {
    return beginMoment.format('DD.MM.YYYY');
  }
  if (beginMoment.year() !== endMoment.year()) {
    return beginMoment.format('DD.MM.YYYY') + ' - ' + endMoment.format('DD.MM.YYYY');
  }
  if (beginMoment.month() !== endMoment.month()) {
    return beginMoment.format('DD.MM.') + ' - ' + endMoment.format('DD.MM.YYYY');
  }
  return beginMoment.format('DD.') + ' - ' + endMoment.format('DD.MM.YYYY');
}

export function firebaseObjectToArray(object): any[] {
  const arr = [];
  if (!object) {
    return arr;
  }
  Object.keys(object).forEach(key => {
    object[key].$key = key;
    arr.push(object[key]);
  });
  return arr;
}

export function firebaseObjectToObjectWithKey(object): any {
  Object.keys(object).forEach(key => {
    object[key].$key = key;
  });
  return object;
}

export function arrayToFirebaseObject(array: any[]): any {
  const object = {};
  array.forEach(item => {
    const key = item.$key;
    console.assert(key != null, '$key is missing from item: ' + item);
    object[key] = JSON.parse(JSON.stringify(item));
    delete object[key].$key;
  });
  return object;
}

export function uniqueKey(): string {
  return Math.random().toString(16).slice(2);
}

export function getFromArrayChecked(array: any[], key: string, title: string) {
  if (!key && !array) {
    return null;
  }
  const value = array.find(v => v != null && (v.$key === key));
  if (value === undefined) {
    throw new Error(`Unexpected ${title}: key=${key} array=${JSON.stringify(array)}`);
  }
  return value;
}

export function getFromMapChecked(map: {}, key: string, title: string) {
  if (!map.hasOwnProperty(key)) {
    throw new Error(`Unexpected ${title}: key=${key} map=${JSON.stringify(map)}`);
  }
  return map[key];
}

export function stringTrimmed(value: string): any {
  if (value) {
    return value.trim();
  }
  return null;
}

// Returns the value if set or a default one
export function valueOrDefault(value: any, default_value: any): any {
  if (value) {
    return value;
  }
  return default_value;
}

// Returns the value or null, even if undefined
export function valueOrNull(value: any): any {
  if (value === undefined) {
    return null;
  }
  return value;
}

// Returns the object or an empty one, even if undefined
export function valueOrEmptyObject(value: any): any {
  if (value) {
    return value;
  }
  return {};
}

// Returns the value or 0, even if undefined
export function valueOrZero(value: any): any {
  if (value) {
    return value;
  }
  return 0;
}
